// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fd-filter-dropdown {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 400px;
  background-color: var(--background);
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  color: var(--text-primary);
  z-index: 1003;
}

.fd-filter-dropdown.slide-in-right {
  transform: translateX(0);
}

.fd-filter-dropdown.slide-out-right {
  transform: translateX(100%);
}

.fd-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.fd-header h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  color: var(--text-primary);
}

.fd-close-button {
  background: none;
  border: none;
  font-size: 2.5rem;
  cursor: pointer;
  padding: 5px;
  color: var(--text-primary);
}

.fd-content {
  flex-grow: 1;
  overflow-y: auto;
}

.fd-section {
  margin-bottom: 30px;
}

.fd-section h4 {
  font-size: 1.6rem;
  margin-bottom: 15px;
  color: var(--text-primary);
}

.fd-genre-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.fd-genre-button {
  background-color: var(--tab-background);
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  color: var(--text-primary);
}

.fd-genre-button.fd-selected {
  background-color: var(--theme-consistent);
  color: var(--text-consistent);
}

.fd-provider-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 8px;
}

.fd-provider-button {
  border: 4px solid transparent;
  border-radius: 8px;
  padding: 3px;
  cursor: pointer;
  transition: border-color 0.2s;
}

.fd-provider-button.fd-selected {
  border-color: var(--theme-consistent);
}

.fd-provider-logo {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.fd-credits-container {
  margin-top: 20px;
  text-align: center;
  font-size: 0.8rem;
  color: var(--text-primary);
}

.fd-justwatch-logo {
  width: 80px;
  margin-top: 10px;
}

@media (max-width: 480px) {
  .fd-filter-dropdown {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/FilterDropdown.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,0CAA0C;EAC1C,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".fd-filter-dropdown {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  max-width: 400px;\n  background-color: var(--background);\n  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);\n  transform: translateX(100%);\n  transition: transform 0.3s ease-in-out;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  color: var(--text-primary);\n  z-index: 1003;\n}\n\n.fd-filter-dropdown.slide-in-right {\n  transform: translateX(0);\n}\n\n.fd-filter-dropdown.slide-out-right {\n  transform: translateX(100%);\n}\n\n.fd-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.fd-header h3 {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 0;\n  color: var(--text-primary);\n}\n\n.fd-close-button {\n  background: none;\n  border: none;\n  font-size: 2.5rem;\n  cursor: pointer;\n  padding: 5px;\n  color: var(--text-primary);\n}\n\n.fd-content {\n  flex-grow: 1;\n  overflow-y: auto;\n}\n\n.fd-section {\n  margin-bottom: 30px;\n}\n\n.fd-section h4 {\n  font-size: 1.6rem;\n  margin-bottom: 15px;\n  color: var(--text-primary);\n}\n\n.fd-genre-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.fd-genre-button {\n  background-color: var(--tab-background);\n  border: none;\n  border-radius: 20px;\n  padding: 8px 16px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n  color: var(--text-primary);\n}\n\n.fd-genre-button.fd-selected {\n  background-color: var(--theme-consistent);\n  color: var(--text-consistent);\n}\n\n.fd-provider-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 8px;\n}\n\n.fd-provider-button {\n  border: 4px solid transparent;\n  border-radius: 8px;\n  padding: 3px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.fd-provider-button.fd-selected {\n  border-color: var(--theme-consistent);\n}\n\n.fd-provider-logo {\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n.fd-credits-container {\n  margin-top: 20px;\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--text-primary);\n}\n\n.fd-justwatch-logo {\n  width: 80px;\n  margin-top: 10px;\n}\n\n@media (max-width: 480px) {\n  .fd-filter-dropdown {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
